import React, { Component } from 'react';
import Form, { SimpleItem, GroupItem } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import API from '../services/AplicationService';
import { GetAuthentication } from '../services/AccountService';
import { showSuccessMessage, showConfirmationMessage, showWarnMessage, handleError } from '../utils/Utility';

const initialState = {
	show: false,
	disabled: false,
	userId: null,
	email: '',
	currentPassword: '',
	newPassword: '',
};
export default class PopupChangePassword extends Component {
	state = { ...initialState };
	constructor(props) {
		super(props);
		this.showPopup = this.showPopup.bind(this);
		this.onClickSave = this.onClickSave.bind(this);
		this.form = React.createRef();

	}
	changePassword() {
		this.setState({ ...this.state, disabled: true });
		let changeCreatePassword = { ...this.state };
		API.post('account/userChangePassword', changeCreatePassword)
			.then(response => {
				this.setState({
					...this.state,
					show: false,
				});
				showSuccessMessage('Senha alterada com sucesso.');
			})
			.catch(error => {
				handleError(error, 'Ocorreu uma falha ao tentar  alterar a senha.');
			})
			.then(error => {
				this.setState({ ...this.state, disabled: false });
			});
	}
	showPopup() {
		this.setState({ ...initialState });
		let userInfo = GetAuthentication();
		this.setState({
			show: true,
			email: userInfo.email,
			userId: userInfo.userId,
		});
	}
	onClickSave = function() {
		this.changePassword();
	};
	render(props) {
		return (
			<Popup
				visible={this.state.show}
				onHiding={() => {
					this.setState({ show: false });
				}}
				height={'auto'}
				width={'30%'}
				dragEnabled={true}
				closeOnOutsideClick={false}
				showTitle={true}
				title={'Alterar senha'}
			>
				<Form formData={this.state} ref={this.form} showColonAfterLabel={false} labelLocation={'left'}>
					<GroupItem colCount={1}>
						<SimpleItem
							colSpan={1}
							dataField={'email'}
							label={{ text: 'Email' }}
							editorOptions={{ disabled: true }}
						/>
						<SimpleItem
							dataField={'currentPassword'}
							label={{ text: 'Senha Atual' }}
							editorOptions={{
								mode: 'password',
								placeholder: 'digite aqui a sua senha atual',
							}}
						/>
						<SimpleItem
							dataField={'newPassword'}
							label={{ text: 'Nova Senha' }}
							editorOptions={{
								mode: 'password',
								placeholder: 'digite aqui a nova senha que deseja',
							}}
						/>
						<SimpleItem colSpan={2}>
							<div className="pull-right">
								<button
									type="button"
									className="btn btn-success"
									onClick={this.onClickSave}
									disabled={this.state.disabled}
								>
									<i className="fa fa-check" />
									&nbsp; Salvar
								</button>
							</div>
						</SimpleItem>
					</GroupItem>
				</Form>
			</Popup>
		);
	}
}
